var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 28,
    viewBox: "0 0 26 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon\\\\\\\\download\\\\\\\\blue"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.25 18.8334C3.80228 18.8334 4.25 19.2811 4.25 19.8334V23.3334C4.25 24.1408 4.84083 24.6667 5.41667 24.6667H20.5833C21.1592 24.6667 21.75 24.1408 21.75 23.3334V19.8334C21.75 19.2811 22.1977 18.8334 22.75 18.8334C23.3023 18.8334 23.75 19.2811 23.75 19.8334V23.3334C23.75 25.1032 22.4007 26.6667 20.5833 26.6667H5.41667C3.59927 26.6667 2.25 25.1032 2.25 23.3334V19.8334C2.25 19.2811 2.69772 18.8334 3.25 18.8334Z",
    fill: "#1D9DBF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape (Stroke)_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.98621 13.2672C8.39092 12.8914 9.02365 12.9148 9.39945 13.3196L13 17.1971L16.6005 13.3196C16.9763 12.9148 17.6091 12.8914 18.0138 13.2672C18.4185 13.643 18.4419 14.2757 18.0661 14.6805L13.7328 19.3471C13.5436 19.5509 13.2781 19.6667 13 19.6667C12.7219 19.6667 12.4564 19.5509 12.2672 19.3471L7.93387 14.6805C7.55806 14.2757 7.5815 13.643 7.98621 13.2672Z",
    fill: "#1D9DBF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape (Stroke)_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 1.33337C13.5523 1.33337 14 1.78109 14 2.33337V18.6667C14 19.219 13.5523 19.6667 13 19.6667C12.4477 19.6667 12 19.219 12 18.6667V2.33337C12 1.78109 12.4477 1.33337 13 1.33337Z",
    fill: "#1D9DBF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadButton);
export default __webpack_public_path__ + "static/media/downloadButton.9f1e713997a7108d1ffbfe7a6388b0a8.svg";
export { ForwardRef as ReactComponent };